import HttpCache from './HttpCache'
import { poolConfigProvider } from './config'
import { adaptorFactory, serviceFactory } from './factory'
import { expiredItemFilter, createdAfterFilter } from './filter'

export default new HttpCache(
  poolConfigProvider,
  adaptorFactory,
  serviceFactory,
  expiredItemFilter,
  createdAfterFilter,
)
